import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { goBack, push } from "react-router-redux";

const PageHero = ({
  title,
  children,
  showBack,
  backLabel,
  backFallbackPath,
  onBack,
  dispatchGoBack,
  dispatchPush,
}) => {
  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
      return;
    }

    // If user landed directly on a page, history stack can be too short.
    if (window.history && window.history.length > 1) {
      dispatchGoBack();
      return;
    }

    if (backFallbackPath) {
      dispatchPush(backFallbackPath);
    }
  };

  return (
    <div className="pageHero">
      <div className="pageHero__inner">
        {showBack && (
          <button
            type="button"
            className="pageHero__back"
            onClick={handleBack}
            aria-label={typeof backLabel === "string" ? backLabel : "Zpět"}
          >
            <span className="pageHero__backIcon" aria-hidden="true">
              ←
            </span>
            <span className="pageHero__backLabel">{backLabel}</span>
          </button>
        )}

        <h1 className="pageHero__title">{title}</h1>
        {children && <div className="pageHero__content">{children}</div>}
      </div>
    </div>
  );
};

PageHero.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  showBack: PropTypes.bool,
  backLabel: PropTypes.node,
  backFallbackPath: PropTypes.string,
  onBack: PropTypes.func,

  // injected by connect
  dispatchGoBack: PropTypes.func.isRequired,
  dispatchPush: PropTypes.func.isRequired,
};

PageHero.defaultProps = {
  showBack: true,
  backLabel: "Zpět",
  backFallbackPath: null,
  onBack: null,
};

export default connect(null, {
  dispatchGoBack: goBack,
  dispatchPush: push,
})(PageHero);
